/* goedkopelaptop.com: teller, sticky koopbalk, keuzehulp-stepper, vergelijker, Startklaar */
(function () {
  'use strict';

  /* ---------- Besteldeadline-teller ---------- */
  function initTellers() {
    var tellers = document.querySelectorAll('[data-gl-cutoff]');
    if (!tellers.length) return;
    var DAGEN = ['zondag', 'maandag', 'dinsdag', 'woensdag', 'donderdag', 'vrijdag', 'zaterdag'];
    function verschuifNaarWerkdag(d) {
      // Verschuif totdat de datum op maandag t/m vrijdag valt
      while (d.getDay() === 0 || d.getDay() === 6) {
        d.setDate(d.getDate() + 1);
      }
      return d;
    }
    function volgendeWerkdag(d) {
      var v = new Date(d);
      v.setDate(v.getDate() + 1);
      return verschuifNaarWerkdag(v);
    }
    function update() {
      var nu = new Date();
      tellers.forEach(function (el) {
        var delen = (el.getAttribute('data-gl-cutoff') || '12:00').split(':');
        var cutoff = new Date(nu);
        cutoff.setHours(parseInt(delen[0], 10) || 23, parseInt(delen[1], 10) || 59, 0, 0);
        // Als vandaag geen werkdag is, of de cutoff-tijd is al voorbij, verschuif naar de volgende werkdag
        if (cutoff <= nu) cutoff.setDate(cutoff.getDate() + 1);
        verschuifNaarWerkdag(cutoff);

        var diff = cutoff - nu;
        var uren = Math.floor(diff / 3600000);
        var minuten = Math.floor((diff % 3600000) / 60000);
        var teller = el.querySelector('[data-gl-teller]');
        if (teller) teller.textContent = uren > 0 ? uren + ' u ' + minuten + ' min' : minuten + ' min';

        // Bezorgdag = de eerste werkdag ná de cutoff-dag (PostNL/DHL bezorgen niet in het weekend)
        var bezorg = volgendeWerkdag(cutoff);
        var vandaag = new Date(nu.getFullYear(), nu.getMonth(), nu.getDate());
        var bezorgDagStart = new Date(bezorg.getFullYear(), bezorg.getMonth(), bezorg.getDate());
        var dagenVerschil = Math.round((bezorgDagStart - vandaag) / 86400000);

        var bezorgTekst;
        if (dagenVerschil === 1) {
          bezorgTekst = 'morgen';
        } else if (dagenVerschil === 2) {
          bezorgTekst = 'overmorgen';
        } else {
          bezorgTekst = DAGEN[bezorg.getDay()];
        }
        var doel = el.querySelector('[data-gl-bezorgdag]');
        if (doel) doel.textContent = bezorgTekst;
      });
    }
    update();
    setInterval(update, 30000);
  }

  /* ---------- Sticky koopbalk ---------- */
  function initStickyKoopbalk() {
    var balk = document.querySelector('[data-gl-sticky]');
    if (!balk) return;
    var hoofdKnop = document.querySelector('product-form .product-form__submit, form[data-type="add-to-cart-form"] [type="submit"]');
    if (!hoofdKnop) return;
    new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var voorbij = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        balk.classList.toggle('is-zichtbaar', voorbij);
        document.body.classList.toggle('gl-sticky-actief', voorbij);
      });
    }, { threshold: 0 }).observe(hoofdKnop);
    var balkKnop = balk.querySelector('[data-gl-sticky-knop]');
    if (balkKnop) {
      balkKnop.addEventListener('click', function () {
        if (hoofdKnop.disabled) hoofdKnop.scrollIntoView({ behavior: 'smooth', block: 'center' });
        else hoofdKnop.click();
      });
    }
  }

  /* ---------- Keuzehulp v3: AND-filtering op de eigen catalogus ----------
     De sectie levert de catalogus mee als JSON. We rekenen hier zelf uit wat
     er overblijft, zodat opties zonder resultaat verdwijnen, stappen zonder
     keuze worden overgeslagen en het resultaat meteen zichtbaar is. Shopify
     combineert meerdere filter.p.tag-waarden met OR, dus die route gaven we op. */
  function initKeuzehulp() {
    var hulp = document.querySelector('[data-gl-keuzehulp]');
    if (!hulp) return;

    var catalogus = [];
    var dataEl = hulp.querySelector('[data-gl-catalogus]');
    if (dataEl) {
      try { catalogus = JSON.parse(dataEl.textContent) || []; } catch (e) { catalogus = []; }
    }

    var keuzes = { budget: null, gebruik: [], formaat: null, os: null, extra: [] };
    var geenExtraWensen = false;

    var cta = hulp.querySelector('[data-gl-keuzehulp-cta]');
    var stappen = Array.prototype.slice.call(hulp.querySelectorAll('[data-gl-stap]'));
    var ctaWrap = hulp.querySelector('[data-gl-cta-panel]');
    var stepperEl = hulp.querySelector('[data-gl-stepper]');
    var badges = Array.prototype.slice.call(hulp.querySelectorAll('[data-gl-badge]'));
    var terug = hulp.querySelector('[data-gl-terug]');
    var tellerEl = hulp.querySelector('[data-gl-keuzehulp-teller]');
    var adviesTekstEl = hulp.querySelector('[data-gl-advies-tekst]');
    var chipsEl = hulp.querySelector('[data-gl-keuzechips]');
    var resultatenEl = hulp.querySelector('[data-gl-resultaten]');
    var onderbouwingEl = hulp.querySelector('[data-gl-onderbouwing]');
    var panelen = stappen.concat(ctaWrap ? [ctaWrap] : []);
    var actief = 0;
    var stepper = panelen.length > 2 && stepperEl && terug;
    var eersteRender = true;
    var wisselTimer = null;
    var bezocht = {};

    /* ---------- filteren ---------- */

    function heeft(p, tag) {
      return tag && p.g && p.g.indexOf(tag) !== -1;
    }

    function past(p, k, negeer) {
      if (negeer !== 'budget' && k.budget && k.budget.max && p.p > k.budget.max) return false;
      if (negeer !== 'gebruik' && k.gebruik.length) {
        // OR: 'hoe meer je kiest, hoe gerichter ons advies' - één raak is genoeg.
        var raak = false;
        for (var g = 0; g < k.gebruik.length; g++) {
          if (heeft(p, k.gebruik[g].tag)) { raak = true; break; }
        }
        if (!raak) return false;
      }
      if (negeer !== 'formaat' && k.formaat && k.formaat.tag && !heeft(p, k.formaat.tag)) return false;
      if (negeer !== 'os' && k.os && k.os.tag && !heeft(p, k.os.tag)) return false;
      if (negeer !== 'extra' && k.extra.length) {
        // AND: 'hoe meer eisen, hoe kleiner het aanbod' - alles moet aanwezig zijn.
        for (var e = 0; e < k.extra.length; e++) {
          if (!heeft(p, k.extra[e].tag)) return false;
        }
      }
      return true;
    }

    function filter(k, negeer) {
      return catalogus.filter(function (p) { return past(p, k, negeer); });
    }

    function kloon() {
      return {
        budget: keuzes.budget,
        gebruik: keuzes.gebruik.slice(),
        formaat: keuzes.formaat,
        os: keuzes.os,
        extra: keuzes.extra.slice()
      };
    }

    // Hoeveel laptops blijven er over als je deze optie zou kiezen, gegeven de
    // antwoorden op de andere vragen.
    function telVoorKnop(knop) {
      var groep = knop.getAttribute('data-gl-groep');
      var tag = knop.getAttribute('data-gl-tag') || '';
      var proef = kloon();
      if (groep === 'budget') {
        var max = parseInt(knop.getAttribute('data-gl-max'), 10) || 0;
        proef.budget = max ? { max: max } : null;
      } else if (groep === 'gebruik') {
        proef.gebruik = tag ? [{ tag: tag }] : [];
      } else if (groep === 'extra') {
        proef.extra = keuzes.extra.filter(function (x) { return x.tag !== tag; });
        if (tag) proef.extra.push({ tag: tag });
      } else {
        proef[groep] = tag ? { tag: tag } : null;
      }
      return filter(proef).length;
    }

    /* ---------- opties en stappen bijwerken ---------- */

    function overslaan(idx) {
      var p = panelen[idx];
      return !!(p && p.hasAttribute('data-gl-stap') && p.getAttribute('data-gl-overslaan') === 'ja');
    }

    function herbereken() {
      hulp.querySelectorAll('[data-gl-answer]').forEach(function (knop) {
        if (knop.hasAttribute('data-gl-escape')) return;
        var n = telVoorKnop(knop);
        knop.hidden = n === 0;
        var tel = knop.querySelector('[data-gl-optie-telling]');
        if (tel) tel.textContent = n > 0 ? (n === 1 ? '1 laptop' : n + ' laptops') : '';
      });
      var beantwoord = {
        budget: !!keuzes.budget,
        gebruik: keuzes.gebruik.length > 0,
        formaat: !!keuzes.formaat,
        os: !!keuzes.os,
        extra: keuzes.extra.length > 0 || geenExtraWensen
      };
      stappen.forEach(function (stap, idx) {
        var echte = Array.prototype.slice.call(stap.querySelectorAll('[data-gl-answer]:not([data-gl-escape])'));
        var bruikbaar = echte.filter(function (k) { return !k.hidden; }).length;
        // Eén overgebleven antwoord is geen keuze: die vraag slaan we over. Maar
        // een vraag die de bezoeker al zag of beantwoordde blijft staan, anders
        // verdwijnt zijn eigen antwoord uit de stepper en uit de terugweg.
        var vast = bezocht[idx] || beantwoord[stap.getAttribute('data-gl-stap-groep')];
        stap.setAttribute('data-gl-overslaan', !vast && bruikbaar < 2 ? 'ja' : 'nee');
      });
    }

    function eersteZichtbaar() {
      for (var i = 0; i < panelen.length; i++) if (!overslaan(i)) return i;
      return panelen.length - 1;
    }

    function vorigeZichtbaar(vanaf) {
      for (var i = vanaf - 1; i >= 0; i--) if (!overslaan(i)) return i;
      return -1;
    }

    function volgendeZichtbaar(vanaf) {
      for (var i = vanaf + 1; i < panelen.length; i++) if (!overslaan(i)) return i;
      return panelen.length - 1;
    }

    function magBewegen() {
      return !(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    }

    function werkStepperBij() {
      var zichtbare = [];
      stappen.forEach(function (stap, idx) { if (!overslaan(idx)) zichtbare.push(idx); });
      badges.forEach(function (badge, idx) {
        var positie = zichtbare.indexOf(idx);
        if (positie === -1) {
          badge.hidden = true;
          badge.removeAttribute('aria-current');
          return;
        }
        badge.hidden = false;
        var cijfer = badge.querySelector('span');
        if (cijfer) cijfer.textContent = positie + 1;
        badge.classList.toggle('is-af', idx < actief);
        badge.classList.toggle('is-actief', idx === actief);
        if (idx === actief) badge.setAttribute('aria-current', 'step');
        else badge.removeAttribute('aria-current');
      });
      if (stepperEl) {
        var hier = zichtbare.indexOf(actief);
        stepperEl.setAttribute(
          'aria-label',
          hier === -1 ? 'Klaar met de vragen' : 'Stap ' + (hier + 1) + ' van ' + zichtbare.length
        );
      }
    }

    function werkTellerBij() {
      if (!tellerEl) return;
      if (actief === panelen.length - 1) {
        tellerEl.hidden = true;
        tellerEl.textContent = '';
        return;
      }
      var n = filter(keuzes).length;
      tellerEl.hidden = false;
      tellerEl.textContent = n === 1
        ? 'Nog 1 laptop die hierbij past'
        : 'Nog ' + n + ' laptops die hierbij passen';
    }

    function toon(i) {
      herbereken();
      actief = Math.max(0, Math.min(i, panelen.length - 1));
      if (overslaan(actief)) actief = volgendeZichtbaar(actief);
      bezocht[actief] = true;
      herbereken();
      panelen.forEach(function (p, idx) { p.classList.toggle('is-actief', idx === actief); });
      if (terug) terug.hidden = vorigeZichtbaar(actief) < 0;
      werkStepperBij();
      werkTellerBij();
      if (actief === panelen.length - 1) tekenAdvies();
      if (!eersteRender) {
        var kop = panelen[actief].querySelector('[data-gl-vraag]');
        if (kop) kop.focus({ preventScroll: true });
        hulp.scrollIntoView({ behavior: magBewegen() ? 'smooth' : 'auto', block: 'start' });
      }
      eersteRender = false;
    }

    // Correctheid mag niet van een timer afhangen: een tweede tik binnen de
    // vertraging annuleert de eerste in plaats van er een stap bij te doen.
    function naVertraging(fn) {
      clearTimeout(wisselTimer);
      wisselTimer = setTimeout(fn, 120);
    }

    function updateAriaState() {
      hulp.querySelectorAll('[data-gl-answer]').forEach(function (b) {
        var groep = b.getAttribute('data-gl-groep');
        var isMulti = b.hasAttribute('data-gl-multi');
        var isClear = b.hasAttribute('data-gl-clear');
        var tag = b.getAttribute('data-gl-tag') || '';
        var pressed = false;
        if (isClear) {
          pressed = geenExtraWensen && keuzes.extra.length === 0;
        } else if (isMulti) {
          pressed = keuzes[groep].some(function (k) { return k.tag === tag; });
        } else if (groep === 'budget') {
          var max = parseInt(b.getAttribute('data-gl-max'), 10) || 0;
          pressed = !!keuzes.budget && (keuzes.budget.max || 0) === max
            && keuzes.budget.label === b.getAttribute('data-gl-label');
        } else if (keuzes[groep]) {
          pressed = (keuzes[groep].tag || '') === tag
            && keuzes[groep].label === b.getAttribute('data-gl-label');
        }
        b.setAttribute('aria-pressed', pressed ? 'true' : 'false');
      });
    }

    /* ---------- advies en resultaat ---------- */

    function esc(s) {
      return String(s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }

    function samen(lijst) {
      if (lijst.length === 1) return lijst[0];
      return lijst.slice(0, -1).join(', ') + ' en ' + lijst.slice(-1)[0];
    }

    function prijs(centen) {
      var euro = Math.floor(centen / 100);
      var rest = centen % 100;
      return rest === 0 ? '€ ' + euro + ',-' : '€ ' + euro + ',' + (rest < 10 ? '0' + rest : rest);
    }

    // Nooit een leeg scherm: laat de smalste eis los tot er weer iets overblijft.
    var GROEPNAAM = { extra: 'je extra wensen', formaat: 'dat formaat', os: 'dat besturingssysteem', gebruik: 'dat gebruik' };

    function resultaat() {
      var proef = kloon();
      var volgorde = ['extra', 'formaat', 'os', 'gebruik'];
      var lijst = filter(proef);
      var losgelaten = [];
      for (var i = 0; i < volgorde.length && lijst.length === 0; i++) {
        var g = volgorde[i];
        var meervoud = g === 'extra' || g === 'gebruik';
        var had = meervoud ? proef[g].length > 0 : !!(proef[g] && proef[g].tag);
        if (!had) continue;
        proef[g] = meervoud ? [] : null;
        losgelaten.push(g);
        lijst = filter(proef);
      }
      return { lijst: lijst, losgelaten: losgelaten };
    }

    function score(p) {
      var s = 0;
      keuzes.gebruik.forEach(function (x) { if (heeft(p, x.tag)) s++; });
      keuzes.extra.forEach(function (x) { if (heeft(p, x.tag)) s++; });
      if (keuzes.formaat && heeft(p, keuzes.formaat.tag)) s++;
      if (keuzes.os && heeft(p, keuzes.os.tag)) s++;
      return s;
    }

    function kaart(p) {
      return '<a class="gl-keuzehulp__kaart" href="' + esc(p.u) + '">'
        + (p.i ? '<img class="gl-keuzehulp__kaart-beeld" src="' + esc(p.i) + '" alt="" loading="lazy" width="320" height="240">' : '')
        + '<span class="gl-keuzehulp__kaart-titel">' + esc(p.t) + '</span>'
        + '<span class="gl-keuzehulp__kaart-prijs">' + prijs(p.p) + '</span>'
        + (p.b ? '' : '<span class="gl-keuzehulp__kaart-status">tijdelijk uitverkocht</span>')
        + '</a>';
    }

    function tekenChips() {
      if (!chipsEl) return;
      var labels = [];
      if (keuzes.budget && keuzes.budget.max) labels.push(keuzes.budget.label);
      keuzes.gebruik.forEach(function (k) { labels.push(k.label); });
      if (keuzes.formaat && keuzes.formaat.tag) labels.push(keuzes.formaat.label);
      if (keuzes.os && keuzes.os.tag) labels.push(keuzes.os.label);
      keuzes.extra.forEach(function (k) { labels.push(k.label); });
      chipsEl.hidden = labels.length === 0;
      chipsEl.innerHTML = labels.map(function (l) {
        return '<li class="gl-keuzehulp__keuze-chip">' + esc(l) + '</li>';
      }).join('');
    }

    function tekenAdvies() {
      var uit = resultaat();
      var lijst = uit.lijst.slice().sort(function (a, b) {
        return (b.b ? 1 : 0) - (a.b ? 1 : 0) || score(b) - score(a) || a.p - b.p;
      });

      tekenChips();

      var gebruikLabels = keuzes.gebruik.map(function (k) { return k.label.toLowerCase(); });
      var zinnen = [];
      if (gebruikLabels.length) {
        var zin = 'Voor <strong>' + esc(samen(gebruikLabels)) + '</strong> adviseren we een refurbished zakelijke laptop';
        if (keuzes.budget && keuzes.budget.max) zin += ' <strong>' + esc(keuzes.budget.label.toLowerCase()) + '</strong>';
        zinnen.push(zin + '.');
      } else if (keuzes.budget && keuzes.budget.max) {
        zinnen.push('We zochten een refurbished zakelijke laptop <strong>' + esc(keuzes.budget.label.toLowerCase()) + '</strong>.');
      }

      if (uit.losgelaten.length) {
        zinnen.push('Op ' + samen(uit.losgelaten.map(function (g) { return GROEPNAAM[g]; }))
          + ' vonden we niets, dus dit komt het dichtst in de buurt.');
      }

      if (lijst.length) {
        zinnen.push(lijst.length === 1
          ? 'Eén laptop past hierbij.'
          : '<strong>' + lijst.length + '</strong> laptops passen hierbij.');
      } else {
        zinnen.push('We vonden hier niets dat past. Bekijk hieronder het hele aanbod.');
      }
      if (adviesTekstEl) adviesTekstEl.innerHTML = zinnen.join(' ');

      if (resultatenEl) {
        var tonen = lijst.slice(0, lijst.length <= 4 ? 4 : 3);
        resultatenEl.hidden = tonen.length === 0;
        resultatenEl.innerHTML = tonen.map(kaart).join('');
      }

      if (onderbouwingEl) {
        var toon = lijst.length > 0 && (gebruikLabels.length > 0 || (keuzes.budget && keuzes.budget.max));
        onderbouwingEl.hidden = !toon;
        onderbouwingEl.textContent = toon
          ? 'Refurbished zakelijke laptops zijn stiller, sneller en gaan langer mee dan modellen uit de consumentenlijn.'
          : '';
      }

      if (cta) {
        cta.setAttribute('href', (keuzes.budget && keuzes.budget.url) || cta.getAttribute('data-gl-basis') || cta.getAttribute('href'));
      }
    }

    /* ---------- interactie ---------- */

    if (cta) cta.setAttribute('data-gl-basis', cta.getAttribute('href') || '');

    hulp.addEventListener('click', function (e) {
      var volgende = e.target.closest('[data-gl-volgende]');
      if (volgende) {
        clearTimeout(wisselTimer);
        toon(volgendeZichtbaar(actief));
        return;
      }
      var knop = e.target.closest('[data-gl-answer]');
      if (!knop) return;
      var groep = knop.getAttribute('data-gl-groep');
      var isMulti = knop.hasAttribute('data-gl-multi');
      var isClear = knop.hasAttribute('data-gl-clear');
      var tag = knop.getAttribute('data-gl-tag') || '';
      var label = knop.getAttribute('data-gl-label') || '';

      if (isClear) {
        keuzes[groep] = [];
        geenExtraWensen = true;
      } else if (isMulti) {
        if (groep === 'extra') geenExtraWensen = false;
        var index = -1;
        keuzes[groep].some(function (k, i) {
          if (k.tag === tag && k.label === label) { index = i; return true; }
          return false;
        });
        if (index >= 0) keuzes[groep].splice(index, 1);
        else keuzes[groep].push({ tag: tag, label: label });
      } else if (groep === 'budget') {
        var max = parseInt(knop.getAttribute('data-gl-max'), 10) || 0;
        keuzes.budget = { max: max, url: knop.getAttribute('data-gl-url') || '', label: label };
      } else {
        keuzes[groep] = { tag: tag, label: label };
      }

      updateAriaState();
      herbereken();
      werkTellerBij();

      if (stepper && !isMulti) naVertraging(function () { toon(volgendeZichtbaar(actief)); });
    });

    if (stepper) {
      hulp.classList.add('gl-keuzehulp--stepper');
      stepperEl.hidden = false;
      terug.addEventListener('click', function () {
        clearTimeout(wisselTimer);
        var vorige = vorigeZichtbaar(actief);
        if (vorige >= 0) toon(vorige);
      });
      toon(eersteZichtbaar());
    } else {
      herbereken();
      tekenAdvies();
    }
  }

  /* ---------- Vergelijker (maximaal 3) ---------- */
  function initVergelijker() {
    var SLEUTEL = 'glVergelijk';
    var balk = document.querySelector('[data-gl-vergelijkbalk]');
    var venster = document.querySelector('[data-gl-vergelijker]');
    if (!balk || !venster) return;

    function lees() {
      try { return JSON.parse(localStorage.getItem(SLEUTEL)) || []; } catch (e) { return []; }
    }
    function schrijf(items) {
      try { localStorage.setItem(SLEUTEL, JSON.stringify(items)); } catch (e) { /* privémodus */ }
    }

    var tekst = balk.querySelector('[data-gl-vergelijk-tekst]');
    var openKnop = balk.querySelector('[data-gl-vergelijk-open]');
    var inhoud = venster.querySelector('[data-gl-vergelijk-inhoud]');

    function vernieuwBalk(melding) {
      var items = lees();
      balk.hidden = items.length === 0;
      document.body.classList.toggle('gl-vergelijkbalk-actief', items.length > 0);
      if (tekst) tekst.textContent = melding || items.length + ' geselecteerd';
      if (openKnop) openKnop.disabled = items.length < 2;
    }

    function syncToggles() {
      var items = lees();
      var handles = items.map(function (i) { return i.handle; });
      document.querySelectorAll('[data-gl-vergelijk]').forEach(function (box) {
        var script = box.closest('label').parentElement.querySelector('[data-gl-productdata]');
        if (!script) return;
        try {
          box.checked = handles.indexOf(JSON.parse(script.textContent).handle) !== -1;
        } catch (e) { /* negeer */ }
      });
    }

    document.addEventListener('change', function (e) {
      var box = e.target.closest('[data-gl-vergelijk]');
      if (!box) return;
      var script = box.closest('label').parentElement.querySelector('[data-gl-productdata]');
      if (!script) return;
      var data;
      try { data = JSON.parse(script.textContent); } catch (err) { return; }
      var items = lees().filter(function (i) { return i.handle !== data.handle; });
      if (box.checked) {
        if (items.length >= 3) {
          box.checked = false;
          vernieuwBalk('Maximaal 3 producten');
          return;
        }
        items.push(data);
      }
      schrijf(items);
      vernieuwBalk();
    });

    function rij(label, veld, achtervoegsel) {
      var items = lees();
      var cellen = items.map(function (i) {
        var w = i[veld];
        return '<td>' + (w === null || w === undefined || w === '' ? '\u2013' : w + (achtervoegsel || '')) + '</td>';
      }).join('');
      return '<tr><th scope="row">' + label + '</th>' + cellen + '</tr>';
    }

    function bouw() {
      var items = lees();
      var koppen = items.map(function (i) {
        return '<td><a href="' + i.url + '">' +
          (i.afbeelding ? '<img src="' + i.afbeelding + '" alt="" loading="lazy">' : '') +
          '<span>' + i.titel + '</span></a>' +
          '<button type="button" class="gl-vergelijker__verwijder" data-gl-verwijder="' + i.handle + '">Verwijder</button></td>';
      }).join('');
      inhoud.innerHTML = '<table class="gl-vergelijker__tabel"><thead><tr><th></th>' + koppen + '</tr></thead><tbody>' +
        rij('Prijs', 'prijs') +
        rij('Nieuwprijs', 'nieuwprijs') +
        rij('Conditie', 'conditie') +
        rij('Accu minimaal', 'accu', '%') +
        rij('Snelheid', 'snelheid') +
        rij('Accuduur', 'accuduur') +
        rij('Scherm', 'scherm') +
        rij('Geluid', 'geluid') +
        '</tbody></table>';
    }

    if (openKnop) {
      openKnop.addEventListener('click', function () {
        bouw();
        venster.hidden = false;
        document.body.classList.add('gl-vergrendeld');
      });
    }
    venster.addEventListener('click', function (e) {
      if (e.target.closest('[data-gl-vergelijk-sluit]') || e.target === venster) {
        venster.hidden = true;
        document.body.classList.remove('gl-vergrendeld');
      }
      var verwijder = e.target.closest('[data-gl-verwijder]');
      if (verwijder) {
        schrijf(lees().filter(function (i) { return i.handle !== verwijder.getAttribute('data-gl-verwijder'); }));
        vernieuwBalk();
        syncToggles();
        if (lees().length < 2) {
          venster.hidden = true;
          document.body.classList.remove('gl-vergrendeld');
        } else {
          bouw();
        }
      }
    });
    balk.addEventListener('click', function (e) {
      if (e.target.closest('[data-gl-vergelijk-wis]')) {
        schrijf([]);
        vernieuwBalk();
        syncToggles();
      }
    });

    vernieuwBalk();
    syncToggles();
  }

  /* ---------- Startklaar-service ---------- */
  function initStartklaar() {
    var box = document.querySelector('[data-gl-startklaar]');
    if (!box) return;
    var status = document.querySelector('[data-gl-startklaar-status]');
    var variantId = parseInt(box.getAttribute('data-variant-id'), 10);
    if (!variantId) return;

    function zetStatus(t) { if (status) status.textContent = t; }

    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        box.checked = cart.items.some(function (i) { return i.variant_id === variantId; });
      })
      .catch(function () { /* stil */ });

    box.addEventListener('change', function () {
      box.disabled = true;
      zetStatus('Even geduld\u2026');
      var klaar = function (tekst) {
        box.disabled = false;
        zetStatus(tekst);
        setTimeout(function () { zetStatus(''); }, 2500);
      };
      if (box.checked) {
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
        })
          .then(function (r) { if (!r.ok) throw new Error(); klaar('Toegevoegd aan je winkelwagen'); })
          .catch(function () { box.checked = false; klaar('Toevoegen mislukt, probeer opnieuw'); });
      } else {
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: String(variantId), quantity: 0 }),
        })
          .then(function (r) { if (!r.ok) throw new Error(); klaar('Verwijderd'); })
          .catch(function () { box.checked = true; klaar('Verwijderen mislukt'); });
      }
    });
  }

  function init() {
    initTellers();
    initStickyKoopbalk();
    initKeuzehulp();
    initVergelijker();
    initStartklaar();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
